module.exports = "<div id=\"pie\"><svg></svg></div>"